'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RouterConfigContext", {
    enumerable: true,
    get: function() {
        return RouterConfigContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const RouterConfigContext = (0, _react().createContext)(null);

//# sourceMappingURL=routerConfigContext.js.map
